import { TabType } from '@heidi/session/contracts';
import { useQuerySessionById } from '@heidi/session/data';

import {
  toWorkspaceArtifact as projectWorkspaceArtifact,
  useWorkspaceSnapshotCore,
  type ProjectWorkspaceSessionReader,
} from '../../../data/projects/workspace/useWorkspaceSnapshot';
import { getWorkHostPort } from '../../work-home/work-home-ports';

export const toWorkspaceArtifact = (
  artifact: Parameters<typeof projectWorkspaceArtifact>[0],
  activeTab: Parameters<typeof projectWorkspaceArtifact>[1],
  pendingLetters: Parameters<typeof projectWorkspaceArtifact>[3] = []
) => projectWorkspaceArtifact(artifact, activeTab, TabType.LETTER, pendingLetters);
const useSessionState: ProjectWorkspaceSessionReader = (
  openSessionId,
  subjectSessionId
) => {
  const pendingLetters = (getWorkHostPort('integrations').usePendingLetters(
    openSessionId ?? ''
  ) ?? []) as NonNullable<Parameters<typeof projectWorkspaceArtifact>[3]>;
  const { data: windows } = getWorkHostPort('session').useQuerySessionWindows({
    sessionId: openSessionId ?? '',
  });
  const activeTab = windows.sessionWindows[windows.activeWindowIndex]?.activeTab as
    | { name: TabType; documentId?: string }
    | undefined;
  const { data: recordingMeta } = useQuerySessionById({
    sessionId: subjectSessionId ?? '',
    select: (session) => ({
      status: session?.recording_status ?? undefined,
      mode: session?.transcribe_mode ?? undefined,
    }),
  });
  return { activeTab, recordingMeta, pendingLetters };
};
export function useWorkspaceSnapshot() {
  return useWorkspaceSnapshotCore(
    getWorkHostPort('session').useActiveSessionId(),
    useSessionState,
    TabType.LETTER
  );
}
